<mat-card-header>
  <mat-card-title>検索結果</mat-card-title>
</mat-card-header>

<mat-card-content class="mat-card-style-search-result">
  <div class="table-responsive">
    <table mat-table multiTemplateDataRows [dataSource]="dataSource" matSort #sort1="matSort" >
      <ng-container matColumnDef="inclusioncontractVisitornumber">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          包括お客さま番号
        </th>
        <td mat-cell *matCellDef="let e">
          {{e.inclusioncontractVisitornumber}}
        </td>
      </ng-container>
      <ng-container matColumnDef="inclusioncontractVisitormei">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          包括お客さま名
        </th>
        <td mat-cell *matCellDef="let e">
          {{e.inclusioncontractVisitormei}}
        </td>
      </ng-container>
      <ng-container matColumnDef="inclusioncontractStateCodeaname">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          包括契約状態
        </th>
        <td mat-cell *matCellDef="let e">
          {{e.inclusioncontractStateCodeaname}}
        </td>
      </ng-container>
      <ng-container matColumnDef="registrationapplicationJokyoCodeaname">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          申請状況
        </th>
        <td mat-cell *matCellDef="let e">
          {{e.registrationapplicationJokyoCodeaname}}
        </td>
      </ng-container>
      <ng-container matColumnDef="inclusioncontractStartdate">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          契約開始日
        </th>
        <td mat-cell *matCellDef="let e">
          {{e.inclusioncontractStartdate | dateString}}
        </td>
      </ng-container>
      <ng-container matColumnDef="inclusioncontractExpirationdate">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          契約終了日
        </th>
        <td mat-cell *matCellDef="let e">
          {{e.inclusioncontractExpirationdate | dateString}}
        </td>
      </ng-container>
      <ng-container matColumnDef="ctrConclusionSosikianame">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          契約担当部署
        </th>
        <td mat-cell *matCellDef="let e">
          {{e.ctrConclusionSosikianame}}
        </td>
      </ng-container>
      <ng-container matColumnDef="contractdateconclusionStaffname">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>
          契約担当者
        </th>
        <td mat-cell *matCellDef="let e">
          {{e.contractdateconclusionStaffname}}
        </td>
      </ng-container>
      <ng-container matColumnDef="inclusioncontractRrkno">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header [style.display]="'none'">
          包括契約履歴番号
        </th>
        <td mat-cell *matCellDef="let e" [style.display]="'none'">
          {{e.inclusioncontractRrkno}}
        </td>
      </ng-container>
      <ng-container matColumnDef="inclusioncontractYearnaiSrno">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header [style.display]="'none'">
          包括契約年度内通番号
        </th>
        <td mat-cell *matCellDef="let e" [style.display]="'none'">
          {{e.inclusioncontractYearnaiSrno}}
        </td>
      </ng-container>
      <ng-container matColumnDef="latestDiscrmCode">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header [style.display]="'none'">
          最新識別コード
        </th>
        <td mat-cell *matCellDef="let e" [style.display]="'none'">
          {{e.latestDiscrmCode}}
        </td>
      </ng-container>
      <ng-container matColumnDef="inclusioncontractYearnaiLatestdiscriminationcode">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header [style.display]="'none'">
          年度内最新識別コード
        </th>
        <td mat-cell *matCellDef="let e" [style.display]="'none'">
          {{e.inclusioncontractYearnaiLatestdiscriminationcode}}
        </td>
      </ng-container>
      <ng-container matColumnDef="inclusioncontractStcode">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header [style.display]="'none'">
          包括契約状態コード
        </th>
        <td mat-cell *matCellDef="let e" [style.display]="'none'">
          {{e.inclusioncontractStcode}}
        </td>
      </ng-container>
      <ng-container matColumnDef="inclusioncontractRegistrationapplicationJokycd">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header [style.display]="'none'">
          登録申請状況コード
        </th>
        <td mat-cell *matCellDef="let e" [style.display]="'none'">
          {{e.inclusioncontractRegistrationapplicationJokycd}}
        </td>
      </ng-container>
      <ng-container matColumnDef="inclusioncontractBreakereqestJokycd">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header [style.display]="'none'">
          解約申請状況コード
        </th>
        <td mat-cell *matCellDef="let e" [style.display]="'none'">
          {{e.inclusioncontractBreakereqestJokycd}}
        </td>
      </ng-container>
      <ng-container matColumnDef="inclusioncontractRegistrationapplicationClscode">
        <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header [style.display]="'none'">
          契約登録種別コード
        </th>
        <td mat-cell *matCellDef="let e" [style.display]="'none'">
          {{e.inclusioncontractRegistrationapplicationClscode}}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true;"></tr>
      <tr mat-row class="clickable-mat-row" *matRowDef="let row; columns: displayedColumnsCol"
        (mouseover)="onMouseoverRow(row.houkatsuOkyakusamaNo)" (mouseout)="onMouseoutRow()"
        (dblclick)="$event ? onClickRow(row, $event): null"></tr>
    </table>
  </div>
</mat-card-content>